import { Clear, Delete, Edit, Person, Share } from "@mui/icons-material";
import { Box, IconButton, Modal, Typography, useMediaQuery } from "@mui/material";
import { Stack, useTheme } from "@mui/system";
import React from "react";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
import { useStore } from "../../../../store/useStore";
import { tokens } from "../../../../store/tokens";
import "./PortfolioModal.css";

const style = {
  padding: 0,
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "95%", sm: "95%", md: 900 },
  height: { xs: "100%", md: 900 },
  maxHeight: "90vh",
  backgroundColor: tokens.color.surface,
  borderRadius: `${tokens.radius.lg}px`,
  boxShadow: 24,
  p: 4,
};

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
};

const PortfolioModal = (props) => {
  const {
    handleClose,
    open,
    portfolio,
    setPortfolioRefer,
    handleOpenPortfolio,
    handleDeletePortfolio,
  } = props;
  const { user } = useStore();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // `firstItem` is already the single pic_object entry — indexing it
  // again with `[0]` (as the previous version did to build `picObjects`)
  // reads a "0" key off a plain object, which is always undefined. That
  // variable was computed and then never used by the slider below (which
  // correctly reads `portfolio?.[0]?.pic_object` directly), so it's
  // removed rather than "fixed" — there was nothing depending on it.
  const firstItem = portfolio?.[0]?.pic_object?.[0] || {};
  const isPoster = firstItem?.poster === user?.sopnoid;

  return (
    <Modal open={open} onClose={handleClose} aria-labelledby="portfolio-modal-title">
      <Stack direction={{ xs: "column", md: "row" }} alignItems="center" justifyContent={"space-between"} spacing={3} sx={style}>
        <Stack sx={{ width: { xs: "100%", md: "40%" } }} spacing={1.5} justifyContent="left" alignItems={"flex-start"}>
          <Stack>
            <Typography variant="caption" sx={{ color: tokens.color.inkMuted, fontWeight: 600 }}>
              Title
            </Typography>
            <Typography id="portfolio-modal-title" variant="subtitle1" sx={{ color: tokens.color.ink }}>
              {firstItem?.title || "N/A"}
            </Typography>
          </Stack>

          <Stack direction={"row"} spacing={2}>
            <IconButton size="small" onClick={() => {}}>
              <Share sx={{ color: tokens.color.teal }} />
            </IconButton>
            <IconButton size="small" onClick={() => navigate("/" + firstItem?.poster)}>
              <Person sx={{ color: tokens.color.teal }} />
            </IconButton>

            {isPoster && (
              <>
                <IconButton
                  size="small"
                  onClick={() => {
                    setPortfolioRefer(firstItem?.port_refer);
                    handleOpenPortfolio(firstItem?.port_refer);
                  }}
                >
                  <Edit sx={{ color: tokens.color.success }} />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={() => {
                    setPortfolioRefer(firstItem?.port_refer);
                    handleDeletePortfolio(firstItem?.port_refer);
                  }}
                >
                  <Delete sx={{ color: tokens.color.error }} />
                </IconButton>
              </>
            )}
          </Stack>
        </Stack>

        <Stack
          spacing={2}
          sx={{ width: { xs: "100%", md: "60%" }, height: { xs: "auto", md: "100%" } }}
          className="slickS"
        >
          <Slider {...settings}>
            {portfolio?.[0]?.pic_object?.map((element, index) => (
              <Box key={element?.port_refer ?? index} sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }}>
                <Stack direction={"row"} justifyContent="center">
                  <Box
                    component="img"
                    alt={element?.title || `Portfolio image ${index + 1}`}
                    sx={{
                      objectFit: "contain",
                      borderRadius: `${tokens.radius.md}px`,
                      width: "100%",
                      height: { xs: "100%", md: "80vh" },
                      cursor: "pointer",
                    }}
                    src={element?.file_url}
                  />
                </Stack>
              </Box>
            ))}
          </Slider>
        </Stack>

        <Clear
          sx={{ position: "absolute", top: 12, right: 12, cursor: "pointer", color: tokens.color.inkMuted }}
          onClick={handleClose}
        />
      </Stack>
    </Modal>
  );
};

export default PortfolioModal;
